// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1uhiP","rootSuccess":"CompleteLink_rootSuccess__e72K9","rootFailure":"CompleteLink_rootFailure__1-CP2","isDisabled":"CompleteLink_isDisabled__1-Xlm"};